import { render, staticRenderFns } from "./NhProductCard.vue?vue&type=template&id=9f7fffb0&scoped=true"
import script from "./NhProductCard.vue?vue&type=script&lang=js"
export * from "./NhProductCard.vue?vue&type=script&lang=js"
import style0 from "./NhProductCard.vue?vue&type=style&index=0&id=9f7fffb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7fffb0",
  null
  
)

export default component.exports